var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cdiv class=\"md-padding\" ng-cloak\u003E\u003Cdiv ng-if=\"!vm.isFinancial\"\u003E\u003Ch2\u003EFinancial summary (FUNDED INVESTORS ONLY)\u003C\u002Fh2\u003E\u003Chelp-box\u003E\u003Cp\u003EFunded investors will be provided with the following financial information:\n\u003C\u002Fp\u003E\u003Cul\u003E\u003Cli\u003EProfit & loss statement\u003C\u002Fli\u003E\u003Cli\u003EBalance sheet\u003C\u002Fli\u003E\u003Cli\u003EExisting obligations summary\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cp\u003EFor information on how to read these statements and details as to what they provide, check out\n\u003Ca href=\"\u002Ffaqs\u002Finvestor\u002Fborrower_financial_information\"\u003EWhat borrower financial information do I get to see?\u003C\u002Fa\u003E in the Investor FAQs.\n\u003C\u002Fp\u003E\u003C\u002Fhelp-box\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"vm.isFinancial &amp;&amp; vm.financialSummary\"\u003E\u003Chelp-box ng-if=\"vm.loanRequest.status === 'fulfilled'\" heading=\"Financial summary\"\u003E\u003Cp\u003E\u003Cmd-icon class=\"warning\"\u003Ewarning\u003C\u002Fmd-icon\u003E Warning: the information on this page was current at {{ vm.loanRequest.auction.endDate | date }}. \nBorrowers' circumstances may vary over the period of a loan.\u003C\u002Fp\u003E\u003C\u002Fhelp-box\u003E\u003Ch2 ng-if=\"vm.loanRequest.status != 'fulfilled'\"\u003EFinancial summary\u003C\u002Fh2\u003E\u003Chelp-box\u003E\u003Cp ng-if=\"vm.financialSummary.message\" ng-bind-html=\"vm.financialSummary.message | fromMarkdown\"\u003E\u003C\u002Fp\u003E\u003Cp ng-if=\"!vm.financialSummary.message\"\u003EFor information on how to read these statements and details as to what they provide, check out\n\u003Ca href=\"\u002Ffaqs\u002Finvestor\u002Fborrower_financial_information\"\u003EWhat borrower financial information do I get to see?\u003C\u002Fa\u003E in the Investor FAQs.\n\u003C\u002Fp\u003E\u003C\u002Fhelp-box\u003E\u003Cdiv class=\"md-padding\" ng-if=\"vm.profitLoss.fields.length &gt; 0\"\u003E\u003Cmd-table-toolbar\u003E\u003Ch3\u003EProfit & loss\u003C\u002Fh3\u003E\u003C\u002Fmd-table-toolbar\u003E\u003Cmd-table-container\u003E\u003Ctable md-table md-progress=\"vm.loading\"\u003E\u003Cthead md-head\u003E\u003Cth md-column\u003E\u003C\u002Fth\u003E\u003Cth ng-repeat=\"heading in vm.profitLoss.headings\" md-column\u003E{{vm.financialSummary.yearLabels[heading]}}\u003C\u002Fth\u003E\u003C\u002Fthead\u003E\u003Ctbody md-body\u003E\u003Ctr md-row ng-repeat=\"field in vm.profitLoss.fields\" ng-class=\"{total: vm.financialSummary.totals[field]}\"\u003E\u003Ctd class=\"field-label\" md-cell\u003E{{ field }}\u003C\u002Ftd\u003E\u003Ctd class=\"accounting\" md-cell ng-repeat=\"heading in vm.profitLoss.headings\" ng-class=\"{negatory: vm.financialSummary.profitLoss[heading][field] &lt; 0}\"\u003E{{ vm.financialSummary.profitLoss[heading][field] | accounting }}\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fmd-table-container\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"md-padding\" ng-if=\"vm.balanceSheet.fields.length &gt; 0\"\u003E\u003Cmd-table-toolbar\u003E\u003Ch3\u003EBalance sheet\u003C\u002Fh3\u003E\u003C\u002Fmd-table-toolbar\u003E\u003Cmd-table-container\u003E\u003Ctable md-table md-progress=\"vm.loading\"\u003E\u003Cthead md-head\u003E\u003Cth md-column\u003E\u003C\u002Fth\u003E\u003Cth ng-repeat=\"heading in vm.balanceSheet.headings\" md-column\u003E{{vm.financialSummary.yearLabels[heading]}}\u003C\u002Fth\u003E\u003C\u002Fthead\u003E\u003Ctbody md-body\u003E\u003Ctr md-row ng-repeat=\"field in vm.balanceSheet.fields\" ng-class=\"{total: vm.financialSummary.totals[field]}\"\u003E\u003Ctd class=\"field-label\" md-cell\u003E{{ field }}\u003C\u002Ftd\u003E\u003Ctd class=\"accounting\" md-cell ng-repeat=\"heading in vm.balanceSheet.headings\" ng-class=\"{negatory: vm.financialSummary.balanceSheet[heading][field] &lt; 0}\"\u003E{{ vm.financialSummary.balanceSheet[heading][field] | accounting }}\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fmd-table-container\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"md-padding\" ng-if=\"vm.debt.fields.length &gt; 0\"\u003E\u003Cmd-table-toolbar\u003E\u003Ch3\u003EExisting obligations\u003C\u002Fh3\u003E\u003C\u002Fmd-table-toolbar\u003E\u003Cmd-table-container\u003E\u003Ctable md-table md-progress=\"vm.loading\"\u003E\u003Cthead md-head\u003E\u003Cth md-column\u003E\u003C\u002Fth\u003E\u003Cth ng-repeat=\"heading in vm.debt.headings\" md-column\u003E{{heading}}\u003C\u002Fth\u003E\u003C\u002Fthead\u003E\u003Ctbody md-body\u003E\u003Ctr class=\"debt\" md-row ng-repeat=\"field in vm.debt.fields\" ng-class=\"{total: vm.financialSummary.totals[field]}\"\u003E\u003Ctd class=\"field-label\" md-cell\u003E{{ field }}\u003C\u002Ftd\u003E\u003Ctd class=\"accounting\" md-cell ng-repeat=\"heading in vm.debt.headings\"\u003E{{ vm.financialSummary.debt[heading][field] | accounting }}\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fmd-table-container\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"fine\" ng-if=\"vm.profitLoss.fields.length &gt; 0 || vm.balanceSheet.fields.length &gt; 0 || vm.debt.fields.length &gt; 0\"\u003E\u003Cp\u003EThis financial summary has been prepared by \u003Ctenant-inline element-id=\"name.short\"\u003E\u003C\u002Ftenant-inline\u003E using the financial information supplied by the borrower.\nThis information is unaudited and although \u003Ctenant-inline element-id=\"name.short\"\u003E\u003C\u002Ftenant-inline\u003E has taken steps to verify its accuracy, provides no warranty\nor guarantee that the information is accurate or complete.\u003C\u002Fp\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;